import { Component, DestroyRef, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { notEmailField } from 'src/app/helpers/form/validators';
import { ThemeService } from 'src/app/services/theme.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'aryel-forgot-password-card',
  templateUrl: './forgot-password-card.component.html',
  styleUrls: ['./forgot-password-card.component.scss'],
})
export class ForgotPasswordCardComponent {
  loading = false;
  sent = false;
  form: UntypedFormGroup;
  validate = false;

  get logo() {
    return this.themeService.logo;
  }

  private destroyRef = inject(DestroyRef);

  constructor(
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private themeService: ThemeService,
    private toastService: ToastService
  ) {
    this.form = formBuilder.group({
      username: ['', [Validators.required, notEmailField()]],
    });
  }

  submit(): void {
    this.validate = true;
    if (this.form.valid) {
      this.loading = true;
      this.userService
        .reserveResetPassword(this.form.controls.username.value)
        .subscribe(
          (res) => {
            this.sent = true;
          },
          (err) => {
            this.toastService.addToast(err);
          }
        )
        .add(() => {
          this.loading = false;
          this.validate = false;
        });
    }
  }
}
